import { Command, HttpVerbType, API_PREFIX, API_VERSION } from "../Command";
import { GetFrontBackComparisonReqData } from "./GetFrontBackComparisonReqData";
import { GetFrontBackComparisonResData } from "./GetFrontBackComparisonResData";

const ENDPOINT = "/cash_flow/front_back_comparison"

export class GetFrontBackComparisonCommand extends Command {
    endPoint: string = API_PREFIX + API_VERSION + ENDPOINT;
    httpVerb: HttpVerbType = "get";
    params: GetFrontBackComparisonReqData = null;

    constructor(params: GetFrontBackComparisonReqData) {
        super();
        this.params = params;
    }

    public async execute(): Promise<GetFrontBackComparisonResData> {
        var res = await this.executeCommand(null, null, this.params);
        return new GetFrontBackComparisonResData(res);
    }

}